import clsx from "clsx";

const PageContainer = ({
  children,
  className = "",
  width = "xl",
  padded = true,
}) => {
  const widthClasses = {
    md: "max-w-4xl",
    lg: "max-w-6xl",
    xl: "max-w-7xl",
    full: "max-w-none",
  };

  return (
    <div
      className={clsx(
        "mx-auto w-full",
        widthClasses[width] || widthClasses.xl,
        padded && "px-4 sm:px-6 lg:px-8",
        className
      )}
    >
      {children}
    </div>
  );
};

export default PageContainer;